<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="User" [matTooltipDisabled]="disabledTooltip(this.user)">
          <mat-label i18n="@@type.AssetsUserDetails.user">User</mat-label>
          <input matInput formControlName="user" id="user" (ngModelChange)="userChanging($event)"
            [(ngModel)]="item.user" (ngModelChange)="userChanged($event)" #user maxlength="255" placeholder="User">
        </mat-form-field>
      </span>

      <span>{{userDisplayName}}</span>

      <span *ngIf="isExcludedByExistingUserDetailsType()" class="crud-editor-warning">Cannot assign eTimber User
        Details, because
        they are already of conflicting types: &nbsp; <ul>
          <li *ngFor="let excludedType of getExcludedByExistingUserDetailsTypes()">{{excludedType |
            cgRefDecode:'SEC_USER_DETAIL_TYPE' | async}}</li>
        </ul></span>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list" [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.AssetsUserDetails.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit"              
              (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="item.businessUnit"              
              (ngModelChange)="businessUnitChanged($event)" #businessUnit              
              placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Landline" [matTooltipDisabled]="disabledTooltip(this.landline)">
          <mat-label i18n="@@type.AssetsUserDetails.landline">Landline</mat-label>
          <input matInput formControlName="landline" id="landline"              
              (ngModelChange)="landlineChanging($event)" [(ngModel)]="item.landline"              
              (ngModelChange)="landlineChanged($event)" #landline              
              maxlength="15" placeholder="Landline">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Mobile" [matTooltipDisabled]="disabledTooltip(this.mobile)">
          <mat-label i18n="@@type.AssetsUserDetails.mobile">Mobile</mat-label>
          <input matInput formControlName="mobile" id="mobile" (ngModelChange)="mobileChanging($event)"
            [(ngModel)]="item.mobile" (ngModelChange)="mobileChanged($event)" #mobile maxlength="15"
            placeholder="Mobile">
        </mat-form-field>
      </span>
    </div>
    <mat-divider></mat-divider>



    <div class="crud-item-section">
      <div class="chip-field">
        <mat-chip-list #costCentresChips>
          <mat-chip *ngFor="let costCentre of item.costCentres" [selectable]="!readOnly" [removable]="!readOnly"
            (removed)="removeCostCentre(costCentre)" color="primary">
            {{costCentresDisplay(costCentre)}}
            <mat-icon matChipRemove *ngIf="!readOnly">cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
        <mat-form-field matTooltip="Select a Cost Centre from the list" [matTooltipDisabled]="disabledTooltip(this.costCentres)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.AssetsUserDetails.costCentres">Cost Centres</mat-label>
          <input matInput [matAutocomplete]="costCentresAutocomplete" [matChipInputFor]="costCentresChips" formControlName="costCentres"
            id="costCentres" #costCentres placeholder="Cost Centres">
          <mat-autocomplete id="costCentresAutocomplete" #costCentresAutocomplete [displayWith]="costCentresDisplay"
            (optionSelected)="selectedCostCentre($event)">
            <mat-option *ngFor="let costCentre of costCentresSelectionList | async" [value]="costCentre">
              {{costCentresDisplay(costCentre)}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="notificationSummaryEmails" id="notificationSummaryEmails"              
              (ngModelChange)="notificationSummaryEmailsChanging($event)" [(ngModel)]="item.notificationSummaryEmails"              
              (ngModelChange)="notificationSummaryEmailsChanged($event)" #notificationSummaryEmails i18n="@@type.AssetsUserDetails.notificationSummaryEmails">
Notification Summary Emails          </mat-slide-toggle>        
        </span>
      </span>

      
    </div>
    
    <mat-divider></mat-divider>
  </form>

  <div *ngIf="showUserDetailsWithAttributes()" class="crud-item-section, userDetailsWithAttributes-section">

    <mat-table #table [dataSource]="userDetailsWithAttributesDataSource"
      class="crud-rows-table, userDetailsWithAttributes-table">

      <ng-container matColumnDef="attributeName">
        <mat-header-cell *matHeaderCellDef class="search-column-small"
          i18n="@@type.UserDetailsWithAttributes.datasource.attributeName">
          Attribute Name
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="search-column-small">
          {{element.attributeName}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="attributeValue">
        <mat-header-cell *matHeaderCellDef class="search-column-smallx2"
          i18n="@@type.UserDetailsWithAttributes.datasource.attributeValue">
          Value
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="search-column-smallx2">
          {{displayAttributeValue(element.attributeName, element.attributeValue)}}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="userDetailsWithAttributesDisplayedColumns" class="search-table">
      </mat-header-row>
      <mat-row *matRowDef="let row; columns: userDetailsWithAttributesDisplayedColumns;" class="search-table"></mat-row>
    </mat-table>
  </div>
</div>